import React from "react";
import "./TopNav.css";

function TopNav() {
  return (
    <div className="top-nav">
      {/* Left side - company contact information */}
      <div className="top-nav-left">
        <span>
          <i className="fa-solid fa-phone"></i>
          +234 806 822 2439
        </span>

        <span>
          <i className="fa-solid fa-envelope"></i>
          info@stridesenergy.com
        </span>
      </div>

      {/* Right side - quick access links */}
      <div className="top-nav-right">
        <a href="https://webmail.stridesenergy.com">Staff Login</a>

        <a href="https://stridesenergy.seamlesshrms.com/">HR Portal</a>

        <a href="https://aar.stridesenergy.com">AAR</a>

        <a href="/#news">News & Updates</a>
      </div>
    </div>
  );
}

export default TopNav;
